import React, { FC, useState } from 'react'
import { IonPopover } from '@ionic/react'
import './index.scss'

interface IProps {
  message: string;
}

const CannotPayTip: FC<IProps> = ({ message }) => {
  const [popoverEvent, setPopoverEvent] = useState<any>()

  return (
    <>
      <i
        className='iconfont icon-info'
        onClick={(e) => {
          e.stopPropagation()
          setPopoverEvent(e)
        }}
      />
      <IonPopover
        cssClass='mall-cannot-pay-tip-popover'
        event={popoverEvent}
        isOpen={!!popoverEvent}
        onDidDismiss={() => setPopoverEvent(undefined)}
      >
        {message}
        <div
          className='acknowledged'
          onClick={(e) => {
            e.stopPropagation()
            setPopoverEvent(undefined)
          }}
        >
          {i18n.t('pay.acknowledged')}
        </div>
      </IonPopover>
    </>
  )
}

export default CannotPayTip
